import {OutdatedPackageTypes, PackageTypes, statuses, ProductStatuses} from '../types/gtins';

const allPackageTypes = Object.values(PackageTypes);
const outdatedPackageTypes = Object.values(OutdatedPackageTypes) as string[];

const actualPackageTypes = allPackageTypes.filter(
    (type): type is Exclude<PackageTypes, OutdatedPackageTypes> =>
        !outdatedPackageTypes.includes(type),
);

export const PackageTypesOptions = actualPackageTypes.map((value) => ({
    key: value,
    value,
}));

export const StatusesOptions = Object.entries(statuses).map(([key, value]) => ({
    key,
    value,
}));

export const ProductStatusesOptions = Object.entries(ProductStatuses).map(([key, value]) => ({
    key,
    value,
}));
